import { render, staticRenderFns } from "./CircletalkTopBarIcon.vue?vue&type=template&id=62b6c59b&"
import script from "./CircletalkTopBarIcon.vue?vue&type=script&lang=js&"
export * from "./CircletalkTopBarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports